export default __webpack_public_path__ + "static/shufflelab-64bdc67c11db2bc5d70417537c0be276.svg";